import React from 'react';
import PresentationalField from './PresentationalField';
const PresentationalFieldBoolean = (props) => (React.createElement(PresentationalField, { ...props, fieldType: "boolean" }));
export default PresentationalFieldBoolean;
